// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import etask from '/util/etask.js';
import * as api from '../../api.js';
import store from '../../store.js';
import {Text} from '../../comp/text';
import {alert} from '../../comp/alert';
import {confirm} from '../../comp/confirm';

const send_request = meta=>etask(function*(){
    const confirmed = yield confirm({
        title: meta.title,
        children: meta.content,
        confirm_label: meta.confirm_label,
    });
    if (!confirmed)
        return;
    this.on('uncaught', console.error);
    let res;
    try {
        res = yield meta.fn();
    } catch(e){
        res = {error: e.message};
    }
    if (res.error)
    {
        alert({
            title: meta.error_label,
            text: res.error,
            negative: true,
        });
    }
    else
    {
        alert({text: meta.success_label, positive: true});
        store.use_devices.invalidate();
    }
});

export const delete_device = d=>send_request({
    title: 'Remove device from account',
    content: <React.Fragment>
      <Text.s>
        You are about to permanently delete device:
        <br/>
        <Text.s accent>{d.title || d.uuid}</Text.s>
      </Text.s>
      <br/>
      <Text.s secondary>
        You will not lose any earnings but you will not be able to earn new
        money from this device.
      </Text.s>
      <Text.s secondary>
        This action is irrevertible. You need
        to uninstall the application on your device too in order to stop
        sharing the bandwidth.
      </Text.s>
    </React.Fragment>,
    confirm_label: 'Delete permanently',
    error_label: 'Error while deleting device',
    success_label: 'Device successfully deleted',
    fn: api.delete_device.bind(1, d.uuid),
});

export const hide_device = d=>send_request({
    title: 'Hide device',
    content: <Text.s>
      You are about to hide device: <b>{d.title || d.uuid}</b>
    </Text.s>,
    confirm_label: 'Hide',
    error_label: 'Error while hiding device',
    success_label: 'Device successfully hidden',
    fn: api.toggle_device.bind(1, d.uuid, false),
});

export const unhide_device = d=>send_request({
    title: 'Unhide device',
    content: <Text.s>
      You are about to unhide device: <b>{d.title || d.uuid}</b>
    </Text.s>,
    confirm_label: 'Unhide',
    error_label: 'Error while unhiding device',
    success_label: 'Device successfully unhidden',
    fn: api.toggle_device.bind(1, d.uuid, true),
});
